var _path, _g, _path2, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberManage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5796 7.38462C11.5796 10.3585 9.21139 12.7692 6.28982 12.7692C3.36825 12.7692 1 10.3585 1 7.38462C1 4.41123 3.36825 2 6.28982 2C9.21139 2 11.5796 4.41123 11.5796 7.38462Z",
    fill: "url(#paint0_linear_9308_7390)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9308_7390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61729 6.57493C8.61729 8.1772 7.34133 9.47603 5.76726 9.47603C4.19319 9.47603 2.91724 8.1772 2.91724 6.57493C2.91724 4.97294 4.19319 3.67383 5.76726 3.67383C7.34133 3.67383 8.61729 4.97294 8.61729 6.57493Z",
    fill: "#E46800"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.04615,
    y: -0.30262,
    width: 20.3153,
    height: 20.5278
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.03px)",
      clipPath: "url(#bgblur_0_9308_7390_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.05628,
    d: "M9.11121 16.085C5.78682 16.0848 3.0946 13.3406 3.09461 9.96094C3.09483 6.58083 5.78696 3.83804 9.11121 3.83789C12.4356 3.83789 15.1286 6.58073 15.1288 9.96094C15.1288 13.3407 12.4357 16.085 9.11121 16.085Z",
    fill: "#FF8227",
    fillOpacity: 0.25,
    stroke: "url(#paint1_linear_9308_7390)",
    strokeWidth: 0.169012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.62315,
    y: 0.46458,
    width: 12.3042,
    height: 12.418
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.27px)",
      clipPath: "url(#bgblur_1_9308_7390_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7390)",
    "data-figma-bg-blur-radius": 2.53518
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0647 3.00685C9.9004 2.98222 9.73341 3.02217 9.60053 3.11788C9.46765 3.21359 9.3798 3.3572 9.35635 3.51705L9.3468 3.61121L9.16198 9.36295C9.142 9.55225 9.20496 9.74172 9.33539 9.88482C9.46582 10.0279 9.65164 10.1114 9.8472 10.1147L15.7473 10.3469C15.9116 10.3537 16.0714 10.2964 16.1912 10.1878C16.311 10.0792 16.381 9.92818 16.3857 9.76814C16.3911 9.74844 16.3932 9.728 16.3919 9.7076C16.2037 6.29489 13.5428 3.47681 10.0647 3.00685Z",
    fill: "url(#paint2_linear_9308_7390)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5.43809,
    y: 6.56321,
    width: 7.10429,
    height: 7.14067
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.27px)",
      clipPath: "url(#bgblur_2_9308_7390_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_9308_7390)",
    "data-figma-bg-blur-radius": 2.53518
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.99024,
    cy: 10.1336,
    rx: 1.01697,
    ry: 1.0352,
    fill: "url(#paint3_linear_9308_7390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98987 9.13257C9.53228 9.13257 9.97324 9.57994 9.97327 10.1335C9.97327 10.6872 9.53229 11.1345 8.98987 11.1345C8.44761 11.1343 8.00745 10.687 8.00745 10.1335C8.00747 9.58007 8.44763 9.13277 8.98987 9.13257Z",
    stroke: "url(#paint4_linear_9308_7390)",
    strokeWidth: 0.0676047
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7390",
    x: -0.293987,
    y: 0.462605,
    width: 12.1225,
    height: 12.2247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.60561,
    result: "effect1_foregroundBlur_9308_7390"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7390_clip_path",
    transform: "translate(1.04615 0.30262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11121 16.085C5.78682 16.0848 3.0946 13.3406 3.09461 9.96094C3.09483 6.58083 5.78696 3.83804 9.11121 3.83789C12.4356 3.83789 15.1286 6.58073 15.1288 9.96094C15.1288 13.3407 12.4357 16.085 9.11121 16.085Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7390",
    x: 6.62315,
    y: 0.46458,
    width: 12.3042,
    height: 12.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.507035,
    dy: 0.845059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.845059
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.52549 0 0 0 0 0.137255 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7390",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7390_clip_path",
    transform: "translate(-6.62315 -0.46458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0647 3.00685C9.9004 2.98222 9.73341 3.02217 9.60053 3.11788C9.46765 3.21359 9.3798 3.3572 9.35635 3.51705L9.3468 3.61121L9.16198 9.36295C9.142 9.55225 9.20496 9.74172 9.33539 9.88482C9.46582 10.0279 9.65164 10.1114 9.8472 10.1147L15.7473 10.3469C15.9116 10.3537 16.0714 10.2964 16.1912 10.1878C16.311 10.0792 16.381 9.92818 16.3857 9.76814C16.3911 9.74844 16.3932 9.728 16.3919 9.7076C16.2037 6.29489 13.5428 3.47681 10.0647 3.00685Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9308_7390",
    x: 5.43809,
    y: 6.56321,
    width: 7.10429,
    height: 7.14067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.845059,
    dy: 0.845059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.845059
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.52549 0 0 0 0 0.137255 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7390",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_9308_7390_clip_path",
    transform: "translate(-5.43809 -6.56321)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.99024,
    cy: 10.1336,
    rx: 1.01697,
    ry: 1.0352
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7390",
    x1: 6.28982,
    y1: 2,
    x2: 6.28982,
    y2: 12.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7390",
    x1: 15.0784,
    y1: 16.0821,
    x2: 2.33229,
    y2: 5.4768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7390",
    x1: 16.3329,
    y1: 4.95279,
    x2: 3.55178,
    y2: 3.15651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7390",
    x1: 9.86301,
    y1: 9.47226,
    x2: 6.42304,
    y2: 9.35081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9308_7390",
    x1: 8.29704,
    y1: 9.33959,
    x2: 9.62248,
    y2: 10.9523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberManage);
export default __webpack_public_path__ + "static/media/memberManage.d51cf02c76189e4df9e94455537f7914.svg";
export { ForwardRef as ReactComponent };